/**
 * Запоминание выбранного принтера в localStorage.
 *
 * Источник истины — привязка на бэке (`workstations[].boundUserId`), локальная запись нужна
 * для двух вещей: показать выбор сразу, не дожидаясь ответа списка, и не потерять его на
 * экранах, где гейтвей облачной печати недоступен (например, на деве, пока его не подняли).
 * Как только список пришёл, расхождение решается в пользу бэка — см. PrinterSidebarStatus.
 */

const STORAGE_KEY = 'cloudPrinter.selectedWorkstation';

/** Запомненный выбор: id для сверки с бэком, имя — чтобы было что показать без списка. */
export interface StoredPrinterSelection {
  id: string;
  name: string;
}

/**
 * Прочитать выбор. Любая проблема (нет доступа к localStorage в приватном режиме,
 * битый JSON от старой версии) трактуется как «выбора нет» — падать из-за кэша нельзя.
 */
export function readSelectedPrinter(): StoredPrinterSelection | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed: unknown = JSON.parse(raw);
    if (
      typeof parsed === 'object' &&
      parsed !== null &&
      typeof (parsed as StoredPrinterSelection).id === 'string' &&
      typeof (parsed as StoredPrinterSelection).name === 'string'
    ) {
      return parsed as StoredPrinterSelection;
    }
    return null;
  } catch {
    return null;
  }
}

export function writeSelectedPrinter(selection: StoredPrinterSelection): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(selection));
  } catch {
    // Квота/приватный режим — работаем без запоминания, привязка всё равно живёт на бэке.
  }
}

export function clearSelectedPrinter(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // см. writeSelectedPrinter
  }
}
